import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import type {
  EventOutcomeGroup,
  EventOutcomeItem,
  EventOutcomePriority,
} from '../event-outcome/event-outcome.types';
import { EVENT_OUTCOME_GROUP_COLORS, EVENT_OUTCOME_PRIORITY_ORDER, matchesOutcomePrioritySelection } from '../event-outcome/event-outcome.types';

@Component({
  selector: 'eventq-event-outcome-list',
  templateUrl: './event-outcome-list.html',
  styleUrl: './event-outcome-list.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqEventOutcomeList {
  readonly groups = input.required<EventOutcomeGroup[]>();
  readonly selectedOutcomeId = input<string | null>(null);
  readonly selectedPriorities = input<EventOutcomePriority[]>([]);
  readonly searchQuery = input('');
  readonly maxHeight = input('276px');

  readonly selectedOutcomeIdChange = output<string>();

  readonly listMaxHeight = computed(() => {
    const height = this.maxHeight();
    return height === 'none' ? null : height;
  });

  readonly visibleGroups = computed(() => {
    const query = this.searchQuery().trim().toLowerCase();
    const selectedPriorities = this.selectedPriorities();
    const availablePriorities = EVENT_OUTCOME_PRIORITY_ORDER.filter((priority) =>
      this.groups().some((group) => group.priority === priority),
    );

    return EVENT_OUTCOME_PRIORITY_ORDER.map((priority) => {
      if (
        !matchesOutcomePrioritySelection(priority, selectedPriorities, availablePriorities)
      ) {
        return null;
      }

      const source = this.groups().find((group) => group.priority === priority);
      if (!source) {
        return null;
      }

      const items = source.items.filter((item) => {
        if (!query) {
          return true;
        }
        return item.label.toLowerCase().includes(query);
      });

      if (items.length === 0) {
        return null;
      }

      return { priority, items };
    }).filter((group): group is { priority: EventOutcomePriority; items: EventOutcomeItem[] } => group !== null);
  });

  rowBackground(priority: EventOutcomePriority): string {
    return EVENT_OUTCOME_GROUP_COLORS[priority];
  }

  onSelect(outcomeId: string): void {
    this.selectedOutcomeIdChange.emit(outcomeId);
  }
}
